const state = {
  notifications: [],
};

const getters = {};

const mutations = {

  set_notification: (state, payload) => {
    const time = new Date().getTime();

    payload.created = time;
    payload.hidden = null;

    state.notifications.push(payload);
  },

  update_notifications: (state, payload) => {
    state.notifications = payload;
  },

};

const actions = {

  nt_set_notification: (context, payload) => {
    context.commit('set_notification', payload);
  },

  nt_update_notifications: (context, payload) => {
    context.commit('update_notifications', payload);
  },

};

export default {
  state,
  getters,
  mutations,
  actions,
};
